module.exports = __webpack_public_path__ + "static/media/0027_IMG_LE_PLAFOND_RAL_9010.a92ac5ef.webp";